/**
 * Rev APAC property mappings are keyed by the kind of platform code they target
 * (investment, entity or asset), not by the C/A/P level the other modules derive
 * from the first letter of the platform code.
 */

export type TApacPropcodeMappingRow = {
    kind: string;
    /** Third Entity Code */
    source_propcode: string;
    /** Platform Entity Code */
    target_propcode: string;
};

export type TApacPropcodeMappingData = {
    file: File | null;
    rows: TApacPropcodeMappingRow[];
    error: string | null;
    warnings: string[];
    isLoading: boolean;
    /** "copied" while the rows are the ones carried over from another deal (Copy deal). */
    origin?: "copied";
};

export const emptyApacPropcodeMappingData: TApacPropcodeMappingData = {
    file: null,
    rows: [],
    error: null,
    warnings: [],
    isLoading: false,
};
